export interface FundingEligibilityCategoryOption {
  value: string;
  label: string;
}

export interface FundingEligibilityCategoryGroup {
  label: string;
  options: FundingEligibilityCategoryOption[];
}

/** Canonical homepage funding-eligibility category groups (WEB-734). */
export const FUNDING_ELIGIBILITY_CATEGORY_GROUPS: FundingEligibilityCategoryGroup[] =
  [
    {
      label: "CONSUMER BRANDS",
      options: [
        { value: "Animals & Pet Supplies", label: "Animals & Pet Supplies" },
        { value: "Apparel & Accessories", label: "Apparel & Accessories" },
        { value: "Baby & Toddler", label: "Baby & Toddler" },
        { value: "Beauty", label: "Beauty" },
        { value: "Electronics", label: "Electronics" },
        { value: "Food & Beverages", label: "Food & Beverages" },
        { value: "Health", label: "Health" },
        { value: "Home & Garden", label: "Home & Garden" },
        { value: "Sporting Goods", label: "Sporting Goods" },
        { value: "Toys & Games", label: "Toys & Games" },
      ],
    },
    {
      label: "OTHER BUSINESSES",
      options: [
        {
          value: "Automotive Services & Dealers",
          label: "Automotive Services & Dealers",
        },
        { value: "Bars & Restaurants", label: "Bars & Restaurants" },
        {
          value: "Childcare & Education",
          label: "Childcare & Education",
        },
        { value: "Construction & Trades", label: "Construction & Trades" },
        { value: "Consulting", label: "Consulting" },
        {
          value: "Gyms, Fitness & Wellness",
          label: "Gyms, Fitness & Wellness",
        },
        {
          value: "Hotels & Accommodation",
          label: "Hotels & Accommodation",
        },
        { value: "Legal & Accounting", label: "Legal & Accounting" },
        { value: "Manufacturing", label: "Manufacturing" },
        {
          value: "Marketing & Creative Agencies",
          label: "Marketing & Creative Agencies",
        },
        {
          value: "Medical & Dental Clinics",
          label: "Medical & Dental Clinics",
        },
        {
          value: "Salons & Personal Services",
          label: "Salons & Personal Services",
        },
        {
          value: "Software & IT Services",
          label: "Software & IT Services",
        },
      ],
    },
  ];

export function getFundingEligibilityCategoryValues(): string[] {
  return FUNDING_ELIGIBILITY_CATEGORY_GROUPS.flatMap((group) =>
    group.options.map((option) => option.value)
  );
}
